import { HeroBackground } from "@/components/home/HeroBackground";

const OPTS = [
  ["both", "C · Liquidity terrain + trade prints", "Halftone liquidity surface on the corners, trade-print stars, lime pulses for whale prints."],
  ["terrain", "A · Liquidity terrain only", "Breathing halftone dot surface; peaks glow lime; dots swell near your cursor."],
  ["stars", "B · Trade-print stars only", "Twinkling prints with occasional purple / lime pulse rings."],
];

const Sample = ({ v, t, d, framed }) => (
  <section data-testid={`bg-sample-${v}${framed ? "-framed" : ""}`} className={`relative overflow-hidden bg-[#08090B] ${framed ? "m-3 rounded-2xl border border-white/[0.08] md:m-5" : "border-t border-white/[0.06]"}`}>
    <HeroBackground variant={v} />
    <div className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-12">
      <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#7D8390]">{t}{framed ? " · framed" : ""}</p>
      <h2 className="mt-5 max-w-4xl font-display text-5xl font-semibold leading-[0.98] tracking-[-0.04em] text-[#ECEBE4] lg:text-7xl">The institutional terminal. <span className="text-[#7D8390]">Built for retail.</span></h2>
      <p className="mt-6 max-w-xl text-lg text-[#9DA3AE]">{d}</p>
      <span className="mt-10 inline-block bg-[#BACD1C] px-7 py-4 font-mono text-[13px] uppercase tracking-[0.14em] text-black">Open free terminal</span>
    </div>
  </section>
);

export default function BgLab() {
  return (
    <div data-testid="bg-lab" className="min-h-screen bg-[#060708]">
      <p className="px-6 pt-8 font-mono text-xs uppercase tracking-[0.3em] text-[#7D8390] md:px-12">TradrQuant · hero background samples (move your mouse over them)</p>
      <Sample v="both" t={OPTS[0][1]} d={OPTS[0][2]} framed />
      {OPTS.map(([v, t, d]) => <Sample key={v} v={v} t={t} d={d} />)}
    </div>
  );
}
